// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__zFC17","footer":"ReportModalFilter_footer__3P8ID"};